import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaLock, FaHome } from 'react-icons/fa';

const AccessDenied = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Obtener el ID del permiso desde los query params
    const queryParams = new URLSearchParams(location.search);
    const permisoId = queryParams.get('permiso');

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
            <div className="bg-white p-8 rounded-xl shadow-lg max-w-md w-full text-center border-t-4 border-red-500">
                <div className="flex justify-center mb-6">
                    <div className="bg-red-100 p-4 rounded-full">
                        <FaLock className="text-5xl text-red-500" />
                    </div>
                </div>

                <h1 className="text-2xl font-bold text-gray-800 mb-2">Acceso Denegado</h1>
                <p className="text-gray-600 mb-6">
                    No tienes los permisos necesarios para visualizar esta sección.
                </p>

                {permisoId && (
                    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6">
                        <p className="text-sm text-gray-500 mb-1">ID del Permiso Requerido:</p>
                        <p className="text-lg font-mono font-bold text-gray-800">{permisoId}</p>
                    </div>
                )}

                <p className="text-sm text-gray-500 mb-8">
                    Si crees que esto es un error, por favor contacta al administrador e indícale el código del permiso mostrado arriba.
                </p>

                <button
                    onClick={() => navigate('/dashboard/welcome')}
                    className="w-full bg-official-from hover:bg-official-to text-white font-bold py-3 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors duration-200"
                >
                    <FaHome />
                    <span>Volver al Inicio</span>
                </button>
            </div>
        </div>
    );
};

export default AccessDenied;
